/** The URL path for the preview app, without leading or trailing slash. */
export const previewPath = 'preview-app';

/** The name for the cookie which enables permanent preview mode */
export const previewModeCookieName = 'EMP_cms_preview_mode';
/** The value for the cookie which enables permanent preview mode */
export const previewModeCookieEnabledValue = '1';
/** The value for the cookie which explicetely disabled preview mode */
export const previewModeCookieDisabledValue = '0';

/** The name for the cookie which enables permanent preview mode */
export const previewLanguageCookieName = 'EMP_cms_preview_language';

/** Cookie names for persisted preview panel settings (audiences, testDate, showAll) */
export const previewAudiencesCookieName = 'EMP_preview_audiences';
export const previewTestDateCookieName = 'EMP_preview_testDate';
export const previewShowAllCookieName = 'EMP_preview_showAll';
